// Global Types
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Components
import Section from '../../../layout/Section';

// Types
type $Props = {
  item: $Model<'CustomPage'>;
};

const ContentSectionView = function ({
  item,
}: $Props) {
  return (
    <Section
      id={webSections[webPages.customPage].details}
      title={item.Name}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: item.Content || '',
        }}
      />
    </Section>
  );
};

export default ContentSectionView;
